import { QueryClient } from '@tanstack/react-query';
import { lazy, Suspense, useEffect } from 'react';
import * as React from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { ENABLE_DEVELOPER_TOOLS } from '../devtools/utils';
export const reactQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            retry: 0
        }
    }
});

const ReactQueryDevtoolsProduction = lazy(() =>
    import(
        /* webpackChunkName: "chunk.react-query-devtools" */ '@tanstack/react-query-devtools/build/lib/index.prod.esm.js'
    ).then(d => ({
        default: d.ReactQueryDevtools
    }))
);
export const NikeReactQueryDevtools = () => {
    const [showReactQueryDevtools, setShowReactQueryDevtools] = React.useState(false);

    useEffect(() => {
        if (ENABLE_DEVELOPER_TOOLS) {
            window.toggleReactQueryDevtools = () => setShowReactQueryDevtools(old => !old);
        }
    }, []);

    if (!showReactQueryDevtools) {
        return null;
    }

    return (
        <ErrorBoundary fallback={null} description={'react-query devtools'}>
            <Suspense fallback={null}>
                <ReactQueryDevtoolsProduction position="bottom-right" />
            </Suspense>
        </ErrorBoundary>
    );
};
